import { Suspense } from "react";
import { Container } from "@mui/material";
import { useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import NavigationBar from "../bars/navigationBar";
import AdminProxyBar from "../bars/adminProxyBar";
import Permit from "../../util/permit";
import { ResponsiveRow } from "../../constants/layout.constants";

import LoadingOverlay from "../overlays/loadingOverlay";
import { Toast } from "../overlays/toast";

// Using Inline Styling
const useStyles = makeStyles((theme) => ({
  navbar: {
    backgroundColor: "#037171",
    minHeight: "6vmin",
    fontSize: `calc(10px + 2vmin)`,
    color: "white",
  },
  menuButton: {
    color: "white!important",
  },
  subMenu: {
    "& .MuiPaper-root": {
      backgroundColor: "#037171",
      color: "white",
    },
  },
  subMenuLink: {
    color: "white",
    textDecoration: "none",
  },
  secureContainer: {
    minHeight: "92.5vmin",
  },
  unsecureContainer: {
    minHeight: "100vmin",
    width: "100vw",
    margin: 0,
    padding: 0,
  },
}));

export default function KodiLayout(props) {
  const { children } = props;
  const classes = useStyles();
  const message = useSelector((state) => state.message);
  const modals = useSelector((state) => state.modals);
  const isAnyModalOpen = modals.openModals > 0;
  return (
    <ResponsiveRow
      sx={{
        position: "relative",
        maxHeight: "100vh",

        flexDirection: "column",
        flexWrap: "nowrap",

        margin: 0,
        padding: 0,

        justifyContent: "flex-start",
        alignItems: "center",

        overflowX: "hidden",
        overflowY: "hidden",
      }}
    >
      <NavigationBar />
      {!isAnyModalOpen && message.display && <Toast />}{" "}
      <Container
        className={classes.secureContainer}
        maxWidth={false}
        sx={{
          "&.MuiContainer-root": {
            height: "90%",
            width: "90%",
            margin: "auto",
            overflowY: "auto",
          },
        }}
        disableGutters={false}
      >
        <Permit permissions="sysadmin">
          <AdminProxyBar />
        </Permit>
        <Suspense
          fallback={<LoadingOverlay message="Page loading... please wait" />}
        >
          {children}
        </Suspense>
      </Container>
    </ResponsiveRow>
  );
}
